// extracted by mini-css-extract-plugin
export default {"container":"scoreDistribution_container__kBcFo","row":"scoreDistribution_row__VeH5l","chart":"scoreDistribution_chart__vlQiL","table":"scoreDistribution_table__7TtMm"};